import React from "react";
import AdminDashboard from "./admin/dashbord/Dashbord";
import VendorDashboard from "./vender/Dashboard";
import SchoolDashboard from "./SchoolDashboard/SchoolDashboard";
import ParentDashboard from "./ParentDashboard/Dashbord";
import { getSubdomainRole } from "../utils/getSubdomainRole";

const Dashboard = () => {
  const subdomainRole = getSubdomainRole();

  const dashboards = {
    admin: <AdminDashboard />,
    parent: <ParentDashboard />,
    school: <SchoolDashboard />,
    vendor: <VendorDashboard />,
  };

  return dashboards[subdomainRole] ?? <div>Dashboard not found</div>;
};

export default Dashboard;
